import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-refresh",
  "use": "icon-refresh-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-refresh\"><g fill=\"transparent\" stroke=\"currentColor\"><path d=\"M20.948 5.808A9.967 9.967 0 0014 3C8.477 3 4 7.477 4 13m2.873 7.014A9.97 9.97 0 0014 23c5.523 0 10-4.477 10-10\" stroke-width=\"1.5\" /><path fill=\"currentColor\" d=\"M4.523 17.523l1.196 3.587 2.39-2.391-3.586-1.196zm18.954-9.046L22.281 4.89l-2.39 2.391 3.586 1.196z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol